type ScheduledCommit = () => void | Promise<void>

type ScheduledEntry = {
  timeoutId: ReturnType<typeof setTimeout>
  commit: ScheduledCommit
}

export type WaterEditCommitScheduler = {
  schedule: (rowId: string, commit: ScheduledCommit) => void
  flush: (rowId: string) => Promise<void>
  flushAll: () => Promise<void>
  cancel: (rowId: string) => void
  dispose: () => void
}

export const createWaterEditCommitScheduler = (delayMs: number): WaterEditCommitScheduler => {
  const entries = new Map<string, ScheduledEntry>()

  const clearScheduled = (rowId: string): ScheduledCommit | null => {
    const entry = entries.get(rowId)
    if (!entry) return null
    clearTimeout(entry.timeoutId)
    entries.delete(rowId)
    return entry.commit
  }

  return {
    schedule(rowId, commit) {
      clearScheduled(rowId)
      const timeoutId = setTimeout(() => {
        const nextCommit = clearScheduled(rowId)
        if (!nextCommit) return
        void nextCommit()
      }, delayMs)

      entries.set(rowId, { timeoutId, commit })
    },

    async flush(rowId) {
      const commit = clearScheduled(rowId)
      if (!commit) return
      await commit()
    },

    async flushAll() {
      const rowIds = Array.from(entries.keys())
      for (const rowId of rowIds) {
        await this.flush(rowId)
      }
    },

    cancel(rowId) {
      clearScheduled(rowId)
    },

    dispose() {
      for (const rowId of Array.from(entries.keys())) {
        clearScheduled(rowId)
      }
    }
  }
}